import { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'
import { transactionProxy } from '../../../../../shared/proxies/transactionProxy'
import DetailLabel from '../../../../../shared/components/ui/forms/DetailLabel'

export function TechnicalsDetailsTab (): ReactElement {
  const { transaction } = useSnapshot(transactionProxy)

  return (
    <div>
      <div className="flex flex-row">
        <DetailLabel additionalOuterClasses="w-1/2" label="Source" value={transaction?.companyName} />
        <DetailLabel additionalOuterClasses="w-1/2" label="Transaction Source" value={transaction?.sourceName} />

      </div>

      <div className="mt-6 flex flex-row">
        <DetailLabel
          additionalOuterClasses="w-full" label="Approval Code"
          value={transaction?.ppSslApprovalCode}
        />

      </div>
      <div className="mt-6 flex flex-row">
        <DetailLabel additionalOuterClasses="w-full" label="External Id" value={transaction?.ppSslTxnId} />
      </div>

    </div>
  )
}
